<template>
  <div class="record-sty">
    <van-cell center :label="item.createTime" v-for="(item,index) in recordData" :key="index">
      <template #title>
        <div class="record-title">余额提现</div>
      </template>
      <template #default>
        <div class="record-amount">+{{item.cashAmount}}</div>
        <van-tag type="primary" v-if="item.state=='0'">提现中</van-tag>
        <van-tag type="success" v-if="item.state=='1'">提现成功</van-tag>
        <van-tag type="danger" v-if="item.state=='2'">提现失败</van-tag>
      </template>
    </van-cell>
  </div>
</template>

<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      recordData: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let that = this
      let phone = localStorage.getItem('phoneNo')
      that.$fetchGet(URL.cashRecord.url, { phone: phone }).then(res => {
        that.recordData = res.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.record-sty {
  font-family: PingFang SC;
  .van-cell {
    line-height: 40px;
    /deep/.van-cell__value{
      display: flex;
      justify-content: space-between;
    }
    .van-cell__label{
      font-size: 10.5px;
      color: #666666;
    }
    .record-title,.record-amount{
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }
    .record-amount{
      color: #FC6E09;
    }
    .van-tag--success,.van-tag--primary,.van-tag--danger{
      width: 59px;
      height: 22.5px;
      display: block;
      text-align: center;
      line-height: 22.5px;
      font-size: 12px;
      color: #fff;
      
    }
    .van-tag--success{
      background: url('./img/withdraw1.png') no-repeat 100%;
      background-size: 100% 100%;
    }
    .van-tag--danger{
      background: url('./img/withdraw2.png') no-repeat 100%;
      background-size: 100% 100%;
    }
    .van-tag--primary{
      background: url('./img/withdraw3.png') no-repeat 100%;
      background-size: 100% 100%;
    }
  }
}
</style>